const LIST_NAMES = {
    HOMEPAGE: 'list_homepage',
    REISEFINDER: 'list_reisefinder',
    DESTINATION: 'list_destination',
    CATEGORY: 'list_category',
    PRODUCT: 'list_interest',
    DEFAULT: 'list_other'
}

const FALLBACK_VALUE = 'n/A';

/**
 * Handles the click event for a teaser link and dispatches a GTM event.
 *
 * @param {HTMLElement} linkEl - The clicked link element.
 */
function handleTeaserLinkClick(linkEl) {
    const logWarning = (message) => console.warn(`SKR: ${message}`);

    const teaser = linkEl.closest('.item-teaser');
    if (!teaser) return logWarning('Could not get the teaser item to track!');

    const teaserList = teaser.parentNode;
    if (!teaserList) return logWarning('Could not get the teaser list to track!');

    const teaserGrid = teaserList.closest('.grid');
    if (!teaserGrid) return logWarning('Could not get the teaser grid to track!');

    const teasers = Array.from(teaserList.children).filter(child => child.classList.contains('item-teaser'));
    const teaserPosition = teasers.indexOf(teaser) + 1;

    const getTextContent = (selector, fallback = FALLBACK_VALUE) => {
        const el = teaser.querySelector(selector);
        return el ? el.textContent.replace(/\s+/g, ' ').trim() : fallback;
    }

    const itemPrice = getTextContent('.item-teaser__info__price');
    const cleanItemPrice = parseInt(itemPrice.replace(/\D/g, '')) || NOT_AVAILABLE_TEXT;

    dispatchGtmEvent({
        event: 'select_item',
        event_name: 'select_item',
        ecommerce: {
            item_list_name: getListName(),
            items: [
                {
                    item_name: getTextContent('.item-teaser__info__subtitle'),
                    item_id: teaser.getAttribute('data-criteo-product-code').trim() || FALLBACK_VALUE,
                    item_region: getTeaserRegion(teaser),
                    item_reiseland: getTextContent('.item-teaser__info__title'),
                    item_position: teaserPosition,
                    price: cleanItemPrice
                }
            ]
        }
    }, true);
}

/**
 * Determines the list name based on breadcrumb structure and URL path.
 *
 * @returns {string} The determined list name from the `LIST_NAMES` constant.
 */
function getListName() {
    const pathName = window.location.pathname;
    const pageDoktype = document.documentElement.getAttribute('page-doktype');
    const breadcrumbLinks = document.querySelectorAll('.breadcrumb__list a');
    const firstBreadcrumb = breadcrumbLinks.length > 0 ? breadcrumbLinks[0].textContent.trim() : '';
    const secondBreadcrumb = breadcrumbLinks.length > 1 ? breadcrumbLinks[1].textContent.trim() : '';

    if (pathName === '/') return LIST_NAMES.HOMEPAGE;

    if (PRODUCT_PAGE_DOKTYPES.includes(pageDoktype)) return LIST_NAMES.PRODUCT;

    if (pathName === '/reisefinder/') return LIST_NAMES.REISEFINDER;

    if (breadcrumbLinks.length === 1) return LIST_NAMES.CATEGORY;

    if (firstBreadcrumb === 'Reiseziele' && secondBreadcrumb && secondBreadcrumb !== 'Reisefinder') {
        return LIST_NAMES.DESTINATION;
    }
}

/**
 * Extracts the region from the classes of a teaser element.
 * @param {HTMLElement} teaser - The teaser element.
 * @returns {string} The region (e.g., 'africa') or 'n/A' if not found.
 */
function getTeaserRegion(teaser) {
    if (!teaser || !teaser.classList) {
        return FALLBACK_VALUE;
    }

    const regionClass = Array.from(teaser.classList).find(className =>
        className.startsWith('item-teaser--')
    );

    // Extract and return the region part, or return 'n/A' if not found
    return regionClass ? regionClass.replace('item-teaser--', '') : FALLBACK_VALUE;
}

const getItemToTrack = () => {
    const itemTeasersLinks = document.querySelectorAll('.item-teaser a');
    if (itemTeasersLinks.length === 0) return;

    itemTeasersLinks.forEach((linkEl) => {
        if (!linkEl.selectItemTrackedInitialized) {
            linkEl.selectItemTrackedInitialized = true;

            linkEl.addEventListener('click', () => {
                handleTeaserLinkClick(linkEl)
            });
        }
    });
}

function initSelectItem() {
    getItemToTrack();
}

window.addEventListener('skr-result-list-updated', () => {
    getItemToTrack();
});

if (['complete', 'interactive'].includes(document.readyState)) {
    requestAnimationFrame(initSelectItem);
} else {
    document.addEventListener('DOMContentLoaded', initSelectItem, { once: true });
}
;
define("skr/tracking/selectItem", function(){});

